import { useState } from "react";
import { Modal, ScrollView, View, TouchableOpacity, Pressable, Text } from "react-native";
import AdminInput from "../../../../components/AdminInput";
import AdminSwitch from "../../../../components/AdminSwitch";
import { SubTitle, SmallText } from "../../../../config/theme/globalStyles";
import Button from "../../../../components/Button";
import AdminAlert from "../../../../components/AdminAlert";
import {
  ViewRow,
  ViewButton,
  ModalBackground,
  ModalContainer,
  Header,
  CloseButton,
  Content,
} from "./../style";
import { AntDesign, Feather } from "@expo/vector-icons";
import CurrencyInput from "react-native-currency-input";
import { getFunctions, httpsCallable } from "firebase/functions";
import { ADMIN_COLORS, ADMIN_FONT } from "../../../../config/theme/adminColors";
import { hasOutsideAboutPage } from "../../../../config/data";
import { useCustomTheme } from "../../../../contexts/useCustomTheme";
import { Field, FieldLabel, FieldError, Hint, InfoBanner, useResponsive } from "../formStyles";

const functions = getFunctions();

// Campo de preço no padrão do painel: o CurrencyInput cuida só da máscara e o
// AdminInput desenha o campo (via `renderTextInput`), então todos os preços ficam
// com a mesma borda, foco e fonte dos demais campos do admin.
//
// Declarado FORA do componente de propósito: definido no corpo do modal, o React
// veria um tipo novo a cada render e remontaria o input, fazendo o campo perder o
// foco a cada tecla digitada.
const PriceField = ({
  label,
  placeholder,
  price,
  onChangeValue,
  onChangeText,
}) => (
  <Field>
    <FieldLabel>{label}</FieldLabel>
    <CurrencyInput
      prefix="R$"
      delimiter=","
      separator="."
      precision={2}
      value={price.value}
      onChangeValue={onChangeValue}
      onChangeText={onChangeText}
      renderTextInput={({ ref, ...inputProps }) => (
        <AdminInput
          {...inputProps}
          placeholder={placeholder}
          returnKeyType="go"
        />
      )}
    />
    <FieldError>{price.error}</FieldError>
  </Field>
);

const CreateStripePlanModal = ({
  isVisible,
  onClose,
  onCreate,
  plansInfo,
  user,
}) => {
  const { customInfo: customizationInfo } = useCustomTheme();

  const [loadingSave, setLoadingSave] = useState(false);
  const [titlePlan, setTitlePlan] = useState({ value: "", error: "" });
  const [infosPlan, setInfosPlan] = useState([]);
  const [itens, setItens] = useState([{ id: 1, item: "Digitar item 1" }]);

  const { isMobile } = useResponsive();

  // Estados de Trial
  const [hasTrial, setHasTrial] = useState(false);
  const [trialDays, setTrialDays] = useState("7");

  // Estado para coletar endereço de cobrança
  const [collectBillingAddress, setCollectBillingAddress] = useState(false);

  // Estado para coletar salesPage
  const [salesPageUrl, setSalesPageUrl] = useState(
    customizationInfo?.salesPageUrl ?? "",
  );

  // Estados de preços - Mensal
  const [pricePlanMonthly, setPricePlanMonthly] = useState({
    value: "",
    error: "",
  });
  const [pricePlanStripeMonthly, setPricePlanStripeMonthly] = useState();
  const [valuePlanWithRSMonthly, setValuePlanWithRSMonthly] = useState("");

  // Estados de preços - Trimestral
  const [pricePlanQuarterlyAtSight, setPricePlanQuarterlyAtSight] = useState({
    value: "",
    error: "",
  });
  const [pricePlanStripeQuarterlyAtSight, setPricePlanStripeQuarterlyAtSight] =
    useState();
  const [valuePlanWithRSQuarterlyAtSight, setValuePlanWithRSQuarterlyAtSight] =
    useState("");
  const [pricePlanQuarterly, setPricePlanQuarterly] = useState({
    value: "",
    error: "",
  });
  const [pricePlanStripeQuarterly, setPricePlanStripeQuarterly] = useState();
  const [valuePlanWithRSQuarterly, setValuePlanWithRSQuarterly] = useState("");

  // Estados de preços - Semestral
  const [pricePlanSemiannualAtSight, setPricePlanSemiannualAtSight] = useState({
    value: "",
    error: "",
  });
  const [
    pricePlanStripeSemiannualAtSight,
    setPricePlanStripeSemiannualAtSight,
  ] = useState();
  const [
    valuePlanWithRSSemiannualAtSight,
    setValuePlanWithRSSemiannualAtSight,
  ] = useState("");
  const [pricePlanSemiannual, setPricePlanSemiannual] = useState({
    value: "",
    error: "",
  });
  const [pricePlanStripeSemiannual, setPricePlanStripeSemiannual] = useState();
  const [valuePlanWithRSSemiannual, setValuePlanWithRSSemiannual] =
    useState("");

  // Estados de preços - Anual
  const [pricePlanYearlyAtSight, setPricePlanYearlyAtSight] = useState({
    value: "",
    error: "",
  });
  const [pricePlanStripeYearlyAtSight, setPricePlanStripeYearlyAtSight] =
    useState();
  const [valuePlanWithRSYearlyAtSight, setValuePlanWithRSYearlyAtSight] =
    useState("");
  const [pricePlanYearly, setPricePlanYearly] = useState({
    value: "",
    error: "",
  });
  const [pricePlanStripeYearly, setPricePlanStripeYearly] = useState();
  const [valuePlanWithRSYearly, setValuePlanWithRSYearly] = useState("");

  const [alertState, setAlertState] = useState({
    visible: false,
    message: null,
  });

  const showAlert = (message) => {
    setAlertState({ visible: true, message });
  };

  const resetFormFields = () => {
    setTitlePlan({ value: "", error: "" });
    setInfosPlan([]);
    setItens([{ id: 1, item: "Digitar item 1" }]);
    setHasTrial(false);
    setTrialDays("7");
    setCollectBillingAddress(false);
    setSalesPageUrl(customizationInfo?.salesPageUrl ?? "");

    setPricePlanMonthly({ value: "", error: "" });
    setPricePlanStripeMonthly();
    setValuePlanWithRSMonthly("");

    setPricePlanQuarterlyAtSight({ value: "", error: "" });
    setPricePlanStripeQuarterlyAtSight();
    setValuePlanWithRSQuarterlyAtSight("");
    setPricePlanQuarterly({ value: "", error: "" });
    setPricePlanStripeQuarterly();
    setValuePlanWithRSQuarterly("");

    setPricePlanSemiannualAtSight({ value: "", error: "" });
    setPricePlanStripeSemiannualAtSight();
    setValuePlanWithRSSemiannualAtSight("");
    setPricePlanSemiannual({ value: "", error: "" });
    setPricePlanStripeSemiannual();
    setValuePlanWithRSSemiannual("");

    setPricePlanYearlyAtSight({ value: "", error: "" });
    setPricePlanStripeYearlyAtSight();
    setValuePlanWithRSYearlyAtSight("");
    setPricePlanYearly({ value: "", error: "" });
    setPricePlanStripeYearly();
    setValuePlanWithRSYearly("");

    setAlertState({ visible: false, message: null });
  };

  const validateForm = () => {
    // Validar nome do plano
    if (!titlePlan.value || titlePlan.value.trim() === "") {
      setTitlePlan({ ...titlePlan, error: "Nome do plano é obrigatório" });
      showAlert("Por favor, preencha o nome do plano");
      return false;
    }

    // Validar trial days se trial estiver ativado
    if (hasTrial && (!trialDays || parseInt(trialDays) < 1)) {
      showAlert("Por favor, preencha um número válido de dias de teste grátis");
      return false;
    }

    // ---- validação extra: A VISTA deve ser <= PARCELADO (soma das parcelas)
    if (pricePlanQuarterlyAtSight.value && pricePlanQuarterly.value) {
      const atSight = Number(pricePlanQuarterlyAtSight.value);
      const parcelTotal = Number(pricePlanQuarterly.value) * 3;
      if (atSight > parcelTotal) {
        showAlert(
          "Valor Trimestral à vista não pode ser maior que o total parcelado (3x).",
        );
        return false;
      }
    }

    // Semestral: atSight <= parcel * 6
    if (pricePlanSemiannualAtSight.value && pricePlanSemiannual.value) {
      const atSight = Number(pricePlanSemiannualAtSight.value);
      const parcelTotal = Number(pricePlanSemiannual.value) * 6;
      if (atSight > parcelTotal) {
        showAlert(
          "Valor Semestral à vista não pode ser maior que o total parcelado (6x).",
        );
        return false;
      }
    }

    // Anual: atSight <= parcel * 12
    if (pricePlanYearlyAtSight.value && pricePlanYearly.value) {
      const atSight = Number(pricePlanYearlyAtSight.value);
      const parcelTotal = Number(pricePlanYearly.value) * 12;
      if (atSight > parcelTotal) {
        showAlert(
          "Valor Anual à vista não pode ser maior que o total parcelado (12x).",
        );
        return false;
      }
    }

    // Verificar se pelo menos um preço foi preenchido
    const hasAtLeastOnePrice =
      pricePlanStripeMonthly > 0 ||
      pricePlanStripeQuarterlyAtSight > 0 ||
      pricePlanStripeQuarterly > 0 ||
      pricePlanStripeSemiannualAtSight > 0 ||
      pricePlanStripeSemiannual > 0 ||
      pricePlanStripeYearlyAtSight > 0 ||
      pricePlanStripeYearly > 0;

    if (!hasAtLeastOnePrice) {
      showAlert(
        "Por favor, preencha pelo menos um valor de preço para o plano",
      );
      return false;
    }

    return true;
  };

  const buildPlanData = () => {
    const planData = {
      titlePlanValue: titlePlan.value,
      infosPlan: infosPlan,
      infosPlanQuarterly: infosPlan,
      infosPlanSemiannual: infosPlan,
      infosPlanYearly: infosPlan,
      order: (Array.isArray(plansInfo) ? plansInfo.length : 0) + 1,
      user: user,
    };

    // Adicionar trial apenas se estiver habilitado
    if (hasTrial) {
      planData.trial = parseInt(trialDays);
    }

    // Adicionar billing_address_collection apenas se estiver habilitado
    if (collectBillingAddress) {
      planData.billing_address_collection = "required";
    }

    // Adicionar hasOutsideAboutPage
    if (hasOutsideAboutPage) {
      planData.salesPageUrl = salesPageUrl;
    }

    // Adicionar apenas preços que foram preenchidos - Mensal
    if (pricePlanStripeMonthly > 0) {
      planData.pricePlanStripeMonthly = pricePlanStripeMonthly;
      planData.valuePlanWithRSMonthly = valuePlanWithRSMonthly;
    }

    // Trimestral
    if (pricePlanStripeQuarterlyAtSight > 0) {
      planData.pricePlanStripeQuarterlyAtSight =
        pricePlanStripeQuarterlyAtSight;
      planData.valuePlanWithRSQuarterlyAtSight =
        valuePlanWithRSQuarterlyAtSight;
    }
    if (pricePlanStripeQuarterly > 0) {
      planData.pricePlanStripeQuarterly = pricePlanStripeQuarterly;
      planData.valuePlanWithRSQuarterly = valuePlanWithRSQuarterly;
    }

    // Semestral
    if (pricePlanStripeSemiannualAtSight > 0) {
      planData.pricePlanStripeSemiannualAtSight =
        pricePlanStripeSemiannualAtSight;
      planData.valuePlanWithRSSemiannualAtSight =
        valuePlanWithRSSemiannualAtSight;
    }
    if (pricePlanStripeSemiannual > 0) {
      planData.pricePlanStripeSemiannual = pricePlanStripeSemiannual;
      planData.valuePlanWithRSSemiannual = valuePlanWithRSSemiannual;
    }

    // Anual
    if (pricePlanStripeYearlyAtSight > 0) {
      planData.pricePlanStripeYearlyAtSight = pricePlanStripeYearlyAtSight;
      planData.valuePlanWithRSYearlyAtSight = valuePlanWithRSYearlyAtSight;
    }
    if (pricePlanStripeYearly > 0) {
      planData.pricePlanStripeYearly = pricePlanStripeYearly;
      planData.valuePlanWithRSYearly = valuePlanWithRSYearly;
    }

    return planData;
  };

  const handleCreate = async () => {
    // Validar formulário
    if (!validateForm()) {
      setLoadingSave(false);
      return;
    }

    setLoadingSave(true);

    const myData = buildPlanData();

    const addPlanOnStripe = httpsCallable(functions, "addPlanOnStripe");

    try {
      await addPlanOnStripe(myData);
      showAlert("Plano adicionado com sucesso!");
      setTimeout(() => {
        resetFormFields();
        if (onCreate) onCreate();
        onClose();
      }, 1500);
    } catch (error) {
      console.error("Erro ao adicionar plano:", error);
      showAlert("Erro ao adicionar plano: " + error.message);
    } finally {
      setLoadingSave(false);
    }
  };

  return (
    <Modal animationType="fade" visible={isVisible} transparent={true}>
      <ModalBackground>
        <ModalContainer>
          <ScrollView
            showsVerticalScrollIndicator={true}
            style={{ width: "100%" }}
          >
            <Header>
              <SubTitle padding="0.2rem 0rem" color={ADMIN_COLORS.ink}>
                Adicionar Novo Plano Stripe:
              </SubTitle>
              <CloseButton
                onPress={() => {
                  resetFormFields();
                  onClose();
                }}
              >
                <Feather name="x" size={20} color={ADMIN_COLORS.ink} />
              </CloseButton>
            </Header>

            <Content>
              <InfoBanner variant="info">
                Planos são vendas online com pagamentos COM recorrência e que os
                conteúdos ficarão disponíveis para seus alunos enquanto fizer
                sentido para eles serem pagantes ativos.
              </InfoBanner>

              <Field>
                <FieldLabel required>Nome do Plano de Assinatura</FieldLabel>
                <AdminInput
                  placeholder="Digitar nome"
                  value={titlePlan.value}
                  onChangeText={(text) =>
                    setTitlePlan({ value: text, error: "" })
                  }
                />
                <FieldError>{titlePlan.error}</FieldError>
              </Field>

              {/* Switch para Trial */}
              <Field>
                <ViewRow>
                  <View style={{ flex: 1 }}>
                    <FieldLabel>
                      (opcional) Oferecer período de teste grátis
                    </FieldLabel>
                  </View>
                  <AdminSwitch
                    value={hasTrial}
                    onValueChange={(value) => setHasTrial(value)}
                  />
                </ViewRow>
                {hasTrial && (
                  <View style={{ marginTop: 10 }}>
                    <FieldLabel>Número de dias de teste grátis</FieldLabel>
                    <AdminInput
                      placeholder="Ex.: 7"
                      value={trialDays}
                      onChangeText={(text) =>
                        setTrialDays(text.replace(/[^0-9]/g, ""))
                      }
                      keyboardType="numeric"
                    />
                    <Hint>
                      Este período será aplicado a todos os preços configurados
                      com teste grátis
                    </Hint>
                  </View>
                )}
              </Field>

              {/* Switch para Coletar Endereço de Cobrança */}
              <Field>
                <ViewRow>
                  <View style={{ flex: 1 }}>
                    <FieldLabel>
                      (opcional) Coletar endereço de cobrança no checkout
                    </FieldLabel>
                  </View>
                  <AdminSwitch
                    value={collectBillingAddress}
                    onValueChange={(value) => setCollectBillingAddress(value)}
                  />
                </ViewRow>
                <Hint>
                  {collectBillingAddress
                    ? "O endereço de cobrança será sempre solicitado no checkout"
                    : "O endereço de cobrança será coletado apenas quando necessário (ex: cálculo de impostos)"}
                </Hint>
              </Field>

              {!hasOutsideAboutPage && (
                <>
                  <Field style={{ marginBottom: 8 }}>
                    <FieldLabel required>Itens incluídos no Plano</FieldLabel>
                    {itens.map((item, index) => (
                      <View key={item.id} style={{ marginBottom: 8 }}>
                        <AdminInput
                          placeholder={item.item}
                          value={infosPlan?.[index] ?? ""}
                          onChangeText={(value) => {
                            setInfosPlan((prev) => {
                              const next = [
                                ...(Array.isArray(prev) ? prev : []),
                              ];
                              next[index] = value;
                              return next;
                            });
                          }}
                        />
                      </View>
                    ))}
                  </Field>

                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-evenly",
                      marginBottom: "1rem",
                    }}
                  >
                    <TouchableOpacity
                      onPress={() => {
                        setItens([
                          ...itens,
                          {
                            id: itens.length + 1,
                            item: `Digitar item ${itens.length + 1}`,
                          },
                        ]);
                      }}
                    >
                      <AntDesign name="plus" size={18} color="#2e2e2e" />
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={() => {
                        if (itens.length > 1) {
                          setItens(itens.slice(0, itens.length - 1));
                        }
                      }}
                    >
                      <AntDesign name="minus" size={18} color="#2e2e2e" />
                    </TouchableOpacity>
                  </View>
                </>
              )}

              {hasOutsideAboutPage && (
                <Field>
                  <FieldLabel>
                    (opcional) Página de vendas do produto
                  </FieldLabel>
                  <InfoBanner variant="warn">
                    Caso você não tenha página de vendas específica para este
                    produto, não edite o campo abaixo, pois a página será a
                    padrão já existente no aplicativo
                  </InfoBanner>
                  <AdminInput
                    placeholder="Ex.: https://www.yourdomain.com/product1"
                    keyboardType="default"
                    returnKeyType="go"
                    value={salesPageUrl}
                    onChangeText={(value) => {
                      setSalesPageUrl(value);
                    }}
                  />
                </Field>
              )}

              <SmallText padding="1rem 0rem" color="#2e2e2e" fontWeight="bold">
                Preencha APENAS os preços que deseja oferecer:
              </SmallText>

              {/* Preços Mensais */}
              <PriceField
                label="Valor Mensal (R$):"
                placeholder="Ex.: 120.00"
                price={pricePlanMonthly}
                onChangeValue={(value) => {
                  setPricePlanMonthly({ value: Number(value), error: "" });
                  setPricePlanStripeMonthly(Number(value) * 100);
                }}
                onChangeText={(text) => setValuePlanWithRSMonthly(`${text}`)}
              />

              {/* Preços Trimestrais */}
              <PriceField
                label="Valor Trimestral à vista (R$):"
                placeholder="Ex.: 300.00"
                price={pricePlanQuarterlyAtSight}
                onChangeValue={(value) => {
                  setPricePlanQuarterlyAtSight({
                    value: Number(value),
                    error: "",
                  });
                  setPricePlanStripeQuarterlyAtSight(Number(value) * 100);
                }}
                onChangeText={(text) =>
                  setValuePlanWithRSQuarterlyAtSight(`${text}`)
                }
              />

              <PriceField
                label="Valor Trimestral (em 3x) (R$):"
                placeholder="Ex.: 108.00"
                price={pricePlanQuarterly}
                onChangeValue={(value) => {
                  setPricePlanQuarterly({ value: Number(value), error: "" });
                  setPricePlanStripeQuarterly(Number(value) * 100);
                }}
                onChangeText={(text) => setValuePlanWithRSQuarterly(`${text}`)}
              />

              {/* Preços Semestrais */}
              <PriceField
                label="Valor Semestral à vista (R$):"
                placeholder="Ex.: 480.00"
                price={pricePlanSemiannualAtSight}
                onChangeValue={(value) => {
                  setPricePlanSemiannualAtSight({
                    value: Number(value),
                    error: "",
                  });
                  setPricePlanStripeSemiannualAtSight(Number(value) * 100);
                }}
                onChangeText={(text) =>
                  setValuePlanWithRSSemiannualAtSight(`${text}`)
                }
              />

              <PriceField
                label="Valor Semestral (em 6x) (R$):"
                placeholder="Ex.: 85.00"
                price={pricePlanSemiannual}
                onChangeValue={(value) => {
                  setPricePlanSemiannual({ value: Number(value), error: "" });
                  setPricePlanStripeSemiannual(Number(value) * 100);
                }}
                onChangeText={(text) => setValuePlanWithRSSemiannual(`${text}`)}
              />

              {/* Preços Anuais */}
              <PriceField
                label="Valor Anual à vista (R$):"
                placeholder="Ex.: 700.00"
                price={pricePlanYearlyAtSight}
                onChangeValue={(value) => {
                  setPricePlanYearlyAtSight({
                    value: Number(value),
                    error: "",
                  });
                  setPricePlanStripeYearlyAtSight(Number(value) * 100);
                }}
                onChangeText={(text) =>
                  setValuePlanWithRSYearlyAtSight(`${text}`)
                }
              />

              <PriceField
                label="Valor Anual (em 12x) (R$):"
                placeholder="Ex.: 62.00"
                price={pricePlanYearly}
                onChangeValue={(value) => {
                  setPricePlanYearly({ value: Number(value), error: "" });
                  setPricePlanStripeYearly(Number(value) * 100);
                }}
                onChangeText={(text) => setValuePlanWithRSYearly(`${text}`)}
              />

              <Hint style={{ marginBottom: 8 }}>
                * Nome do plano é obrigatório. Preencha pelo menos um valor de
                preço.
              </Hint>

              {alertState.visible && (
                <AdminAlert
                  variant={
                    alertState.message?.includes("sucesso")
                      ? "success"
                      : "error"
                  }
                >
                  {alertState.message}
                </AdminAlert>
              )}

              <View
                style={[
                  styles.footer,
                  isMobile && { flexDirection: "column-reverse" },
                ]}
              >
                <Pressable
                  onPress={() => {
                    resetFormFields();
                    onClose();
                  }}
                  disabled={loadingSave}
                  style={({ hovered }) => [
                    styles.btn,
                    styles.btnSecondary,
                    hovered && { backgroundColor: "#E5E7EB" },
                  ]}
                >
                  <Text
                    style={[
                      styles.btnText,
                      { color: ADMIN_COLORS.secondaryText },
                    ]}
                  >
                    Cancelar
                  </Text>
                </Pressable>
                <Pressable
                  onPress={handleCreate}
                  disabled={loadingSave}
                  style={({ hovered }) => [
                    styles.btn,
                    styles.btnPrimary,
                    hovered && { backgroundColor: ADMIN_COLORS.accentDark },
                    loadingSave && { opacity: 0.7 },
                  ]}
                >
                  <Text
                    style={[
                      styles.btnText,
                      { color: ADMIN_COLORS.primaryText },
                    ]}
                  >
                    {loadingSave ? "Salvando..." : "Salvar"}
                  </Text>
                </Pressable>
              </View>
            </Content>
          </ScrollView>
        </ModalContainer>
      </ModalBackground>
    </Modal>
  );
};

export default CreateStripePlanModal;

const styles = {
  footer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 12,
    padding: 20,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: ADMIN_COLORS.border,
    backgroundColor: ADMIN_COLORS.surfaceSubtle,
  },
  btn: {
    minHeight: 44,
    borderRadius: 10,
    paddingHorizontal: 22,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  btnPrimary: { backgroundColor: ADMIN_COLORS.accent },
  btnSecondary: { backgroundColor: ADMIN_COLORS.secondaryBg },
  btnText: { fontFamily: ADMIN_FONT, fontSize: 14, fontWeight: "600" },
};
